import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { apiConfig } from 'src/environments/environment';

const _processFormData = (data: any, contentType: any) => {
  let formData = new FormData();
  if (contentType == 'application/json') {
    return data;
    formData = data;
  } else {
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        if (data[key].blob) {
          // blob name
          // formData.set(key, data[key].blob, data[key].name);
          formData.append(key, data[key].blob, data[key].name);
        } else {
          // formData.set(key, data[key]);
          formData.append(key, data[key]);
        }
      }
    });
  }
  return formData;
};

@Injectable({
  providedIn: 'root',
})
export class HttpsService {

  constructor(private http: HttpClient) { }

  get Http() {
    return this.http;
  }

  _get(endpoint: any, data: any, options: any) {
    /*const params = [];
    //_processFormData(data || {}, ((options || {}).headers || {})['Content-Type']).forEach((value, key) => params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value)));
    if (params.length > 0) {
      endpoint += (endpoint.indexOf('?') >= 0 ? '&' : '?') + params.join('&');
    }*/
    return this._makeRequest('GET', endpoint, data, options);
  }

  _post(endpoint: any, data: any, options: any) {
    const formData = _processFormData(
      data || {},
      ((options || {}).headers || { 'Content-Type': 'multipart/form-data' })[
      'Content-Type'
      ],
    );
    return this._makeRequest('POST', endpoint, formData, options);
  }

  _put(endpoint: any, data: any, options: any) {
    const formData = _processFormData(
      data || {},
      ((options || {}).headers || { 'Content-Type': 'multipart/form-data' })[
      'Content-Type'
      ],
    );
    return this._makeRequest('PUT', endpoint, formData, options);
  }

  _delete(endpoint: any, options: any) {
    return this._makeRequest('DELETE', endpoint, undefined, options);
  }

  private _makeRequest(type: string = 'GET', endPoint: string, data: any, options: any): Observable<any> {
    endPoint = `${apiConfig.baseUrl + endPoint}`;
    let request: Observable<any>;
    if (type === 'POST') {
      request = this.http.post(endPoint, data, options);
    } else if (type === 'PUT') {
      request = this.http.put(endPoint, data, options);
    } else if (type === 'DELETE') {
      request = this.http.delete(endPoint, options);
    } else {
      options.params = data;
      request = this.http.get(endPoint, options);
    }
    return request.pipe(map((response: any) => {
      let error = 'SYSTEM_ERROR';
      if (response.status === 200) {
        if (!response.body.error) {
          return response.body.result || response.body;
        } else {
          error = response.body.result;
        }
      }
      throw new Error(error);
    }), catchError((error: HttpErrorResponse) => throwError(error)));
  }

}
